var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.847V17.347C18.3343 17.5791 18.2867 17.8088 18.1938 18.0214C18.1008 18.2341 17.9644 18.425 17.7934 18.5819C17.6224 18.7388 17.4205 18.8582 17.2006 18.9326C16.9808 19.0069 16.7478 19.0345 16.5167 19.0137C13.9524 18.735 11.4892 17.8588 9.325 16.4553C7.31152 15.1759 5.60445 13.4688 4.325 11.4553C2.91665 9.28133 2.0402 6.80615 1.76667 4.23032C1.74584 3.99988 1.77323 3.76762 1.84708 3.54834C1.92094 3.32906 2.03964 3.12756 2.19564 2.95667C2.35163 2.78578 2.5415 2.64925 2.75316 2.55576C2.96481 2.46227 3.19362 2.41387 3.425 2.41366H5.925C6.32942 2.40967 6.72149 2.55289 7.02813 2.8166C7.33478 3.08031 7.53506 3.44653 7.59167 3.84699C7.69719 4.64704 7.89288 5.43259 8.175 6.18865C8.28712 6.48692 8.31139 6.81108 8.24492 7.12272C8.17846 7.43436 8.02405 7.72041 7.8 7.94699L6.74167 9.00532C7.92796 11.0916 9.65538 12.819 11.7417 14.0053L12.8 12.947C13.0266 12.7229 13.3126 12.5685 13.6243 12.5021C13.9359 12.4356 14.2601 12.4599 14.5583 12.572C15.3144 12.8541 16.0999 13.0498 16.9 13.1553C17.3048 13.2124 17.6745 13.4163 17.9388 13.7282C18.2031 14.0401 18.3435 14.4383 18.3333 14.847Z",
    stroke: "#0A142F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9cb2282de7a6c458fda3238a0325fd41.svg";
export { ForwardRef as ReactComponent };